import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'machine_ifline_motor_speed',
  message0: '%{BKY_CUSTOM_MACHINE_IFLINE_MOTOR_SPEED}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/SwWXQ3k/ifline.jpg',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'input_value',
      name: 'SPEED',
      check: 'Number'
    },
    {
      type: 'field_dropdown',
      name: 'SIDE',
      options: [
        ['%{BKY_CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_V_BOTH}', 'speed'],
        ['%{BKY_CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_V_LEFT}', 'speedLeft'],
        ['%{BKY_CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_V_RIGHT}', 'speedRight']
      ]
    }
  ],
  inputsInline: true,
  previousStatement: null,
  nextStatement: null,
  style: 'motor_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifline_motor_speed'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifline_motor_speed'] = function (block) {
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifline = 'import ifline'
  let numberSpeed = Blockly.Python.valueToCode(
    block,
    'SPEED',
    Blockly.Python.ORDER_ATOMIC
  )
  numberSpeed = numberSpeed ? numberSpeed : 0
  let dropdownSide = block.getFieldValue('SIDE')
  let code = `ifline.${dropdownSide}(${numberSpeed})\n`
  return code
}
